<div class="notification is-danger mb-4" *ngIf="show">
  <div class="icon">
    <i class="far fa-times-circle fa-lg"></i>
  </div>
  <span>
    {{ errorMessage }}
  </span>
</div>
